import { Box, Stack, Typography } from '@mui/material'
import OrderDetails from '../order-details/order-details.component'
import ArrowLeft from 'assets/icons/ArrowLeft.png'
import { useDispatch, useSelector } from 'react-redux'
import { clearSelectedOrder } from '../../../store/orders/orders.slice'
import OrderSelection from '../order-selection/order-selection.component'
import { RootState } from 'store'

const MobileOrderSelection = () => {
  const dispatch = useDispatch()

  const selectedOrder = useSelector(
    (state: RootState) => state.orders.selectedOrder
  )

  return (
    <>
      {!selectedOrder?.loadNumber ? (
        <Box p={2}>
          <OrderSelection />
        </Box>
      ) : (
        <Stack spacing={1}>
          <Stack
            direction="row"
            sx={{ cursor: 'pointer', alignItems: 'center' }}
            onClick={() => dispatch(clearSelectedOrder())}
          >
            <Box px={1} pt={1}>
              <img src={ArrowLeft} alt="arrow left" width={24} height={24} />
            </Box>
            <Typography>Go Back</Typography>
          </Stack>
          <OrderDetails />
        </Stack>
      )}
    </>
  )
}

export default MobileOrderSelection
